import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild,
} from '@angular/core';

import { Base64 } from 'ib/internetbank-core/ib-models/common-types';

import { AppealHidingTextComponent } from '../appeal-hiding-text/appeal-hiding-text.component';
import { Appeal } from '../statements-model';

@Component({
	selector: 'app-appeal-item',
	templateUrl: './appeal-item.component.html',
	styleUrls: ['./appeal-item.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AppealItemComponent {


	@Input()
	public item: Appeal | undefined;

	@Output()
	public viewedAppeal: EventEmitter<{
		regNumber: string;
		status: string | undefined
	}> = new EventEmitter();

	@ViewChild(AppealHidingTextComponent)
	public appealHiddingText: AppealHidingTextComponent;

	public readonly considered = 'Рассмотрено';

	public setViewedAppeal(): void {
		this.appealHiddingText.appealOpen$$.next();
		this.appealHiddingText.appealOpen$$.complete();

		if (this.item?.isFirstVisible) {
			this.item.isFirstVisible = false;
			this.viewedAppeal.emit({
				regNumber: this.item.regNumber,
				status: this.item.status,
			});
		}
	}
	public async getFileUrl(base64: Base64): Promise<string> {

		const base64WithoutPrefix = base64.includes(',')
			? base64.split(',')[1]
			: base64;
		const response = await fetch(`data:application/pdf;base64,${base64WithoutPrefix}`);
		const blob = await response.blob();
		const url = URL.createObjectURL(blob);

		return url;

	}

	public async openFile(base64: Base64): Promise<void> {
		const url = await this.getFileUrl(base64);

		window.open(url, '_blank');
		setTimeout(() => URL.revokeObjectURL(url), 60000);

	}
}
